module.exports = __webpack_public_path__ + "img/acaki2.a4a2b9b0.jpg";